import React, {useEffect, useState} from 'react';
import SectionLayout from '../../CommonComponents/Layout/sectionLayout';
import {
  Table,
  Select,
  Form,
  Tag,
  Skeleton,
  Row,
  Col,
  Modal,
  Button,
} from 'antd';
import EditableCell, {
  resetAttendanceDependentOptions,
} from '../../CommonComponents/EditableCell';
import './style.css';
import ConfirmationAction from '../../CommonComponents/PaymentConfirmationAction';
import FoodOptionsExpandable from '../AddAttendees/ExpandForm';
import {useNavigate, useParams} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {
  formValueChangeHandler,
  formatCurrencyByLocalChapter,
  validatePaymentPrice,
} from '../../../Util/commonUtility';
import PromotionalCodeInputCart from '../../CommonComponents/CouponCodeInputCart';
import CustomCollapse from '../../CommonComponents/CommonAccordian';
import NavigationComponent from '../../CommonComponents/CommonBackButton';
import AdminActionsDropdown from '../../CommonComponents/AdminActionsDropdown/AdminActionsDropdown';
import SponsorOptionPageHeroText from '../../CommonComponents/SponsorOptionPageHeroText';
import useLocalization from '../../../Localization';
import {LANGUAGES} from '../../../Localization/LanguageContext';

const formatAttendeeFieldOrNA = (value) => {
  const trimmed = value == null ? '' : String(value).trim();
  return trimmed && trimmed.toLowerCase() !== 'null' ? trimmed : 'N/A';
};

const AttendeesCartComponent = ({
  attendeesData,
  allEventOptionsFoodData,
  allEventOptionsRegistrationData,
  inPersonRemaining,
  companiesData,
  totalCartPrice,
  editAttendeeById,
  deleteAttendeeById,
  applyCouponCode,
  paymentByUserRegistration,
  appliedCartCoupon,
  eventISOnline,
  eventType,
  eventName,
  eventAvailableForWebcast,
  eventLocalChapterData,
}) => {
  const {ApplicationString, currentLanguage} = useLocalization();
  const {id, transactionId} = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [editingKey, setEditingKey] = useState('');
  const isEditing = (record) => record.id === editingKey;
  const [expandedRowKeys, setExpandedRowKeys] = useState();
  const [isAddAttendee, setIsAddAttendee] = useState(false);
  const [couponVerifiedAttendee, setCouponVerifiedAttendee] = useState(false);
  const [couponVerifiedCart, setCouponVerifiedCart] = useState(false);
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState(false);
  const [attendeeInPersonChecked, setAttendeeInPersonChecked] = useState(false);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  const handleConfirm = () => {
    if (validatePaymentPrice(totalCartPrice?.discounted_price, dispatch)) {
      return;
    }
    return paymentByUserRegistration(id);
  };

  const edit = (record) => {
    const EditData = {
      ...record,
      attendee_email_confirm: record?.attendee_email
        ? record?.attendee_email
        : '',
      food_option: record?.food_option
        ? record?.food_option?.event_option_id
        : 'no-food',
      registration_option: record?.registration_option?.event_option_id,
      coupon_code: record?.discount_code,
    };
    form.setFieldsValue({
      ...EditData,
    });
    setAttendeeInPersonChecked(
      record.registration_type?.toLowerCase() === 'webcast' ? false : true,
    );
    setEditingKey(record.id);
  };

  const cancel = () => {
    setIsAddAttendee(false);
    setEditingKey('');
  };
  const handleAttendeeInPersonChange = (e) => {
    setAttendeeInPersonChecked(e.target.value === 'webcast' ? false : true);
    if (e.target.value === 'webcast') setOpenConfirmationPopup(true);
  };
  const save = async (attendeeData) => {
    try {
      const row = await form.validateFields();
      const EditData = {
        ...row,
        food_option:
          row.food_option === 'no-food' ||
          eventType?.toLowerCase() === 'webcast'
            ? {}
            : {
                type: 'food',
                event_option_id: row?.food_option,
                qty: 1,
                id: attendeeData?.event_registration_options?.food?.id,
              },
        event_id: id && parseInt(id),
        registration_option: {
          type: 'registration',
          event_option_id: row?.registration_option,
          qty: 1,
          id: attendeeData?.event_registration_options?.registration?.id,
        },
        registration_type: attendeeInPersonChecked ? 'In-Person' : 'Webcast',
      };
      editAttendeeById(
        EditData,
        attendeeData.id,
        setEditingKey,
        form,
        setIsAddAttendee,
      );
    } catch (errInfo) {
      console.error('Validation Failed:', errInfo);
    }
  };

  useEffect(() => {
    if (attendeesData?.length === 0) {
      const loading = !attendeesData || attendeesData.length === 0;
      setLoading(loading);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [attendeesData]);

  const updateRecord = (record) => {
    const newData = [...data];
    const index = newData.findIndex((item) => record.id === item.id);
    newData[index] = record;
    setData(newData);
  };
  const hideInPersonCheckbox = () => {
    if (eventType?.toLowerCase() === 'webcast' || eventISOnline) {
      return true;
    } else if (!eventAvailableForWebcast?.isAvailable) {
      return true;
    } else {
      return false;
    }
  };

  const hideOptionsColumn = () => {
    if (transactionId) {
      return false;
    } else {
      return true;
    }
  };
  const handleCancel = () => {
    navigate(`/addAttendees/${id}`);
  };
  const columns = [
    {
      title: ApplicationString['addAttendeeComponent.table.title.name'],
      dataIndex: 'name',
      key: 'name',
      editable: true,
      width: '15%',
      render: (text, record) => {
        return (
          <Tag prefixCls='regularAttendeesTag'>
            {record.attendee_first_name} {record.attendee_last_name}
          </Tag>
        );
      },
    },
    {
      title: ApplicationString['addAttendeeComponent.table.title.email'],
      dataIndex: 'attendee_email',
      key: 'email',
      width: '18%',
      editable: true,
      render: (text) => {
        return <Tag prefixCls='regularAttendeesTag'>{text}</Tag>;
      },
    },

    {
      title: ApplicationString['addAttendeeComponent.table.title.option'],
      dataIndex: 'option',
      key: 'registration_and_food_option',
      width: '20%',
      editable: hideOptionsColumn(),
      render: (_, record) => {
        const registrationName = record.registration_option?.name;
        const registrationPrice = record.registration_option?.price;
        const foodName =
          record.food_option?.name ||
          ApplicationString['addAttendeesComponent.label.noFoodOption'];
        const foodPrice = record.food_option?.price;
        return (
          <div className='option-tag-container'>
            <Tag prefixCls='regularAttendeesTag'>
              {ApplicationString['addAttendeeComponent.option.registration']}:{' '}
              {registrationName} -{' '}
              {formatCurrencyByLocalChapter(
                registrationPrice,
                eventLocalChapterData,
              )}
            </Tag>
            {eventType !== 'Webcast' && (
              <Tag prefixCls='regularAttendeesTag'>
                {ApplicationString['addAttendeeComponent.option.food']}:{' '}
                {foodName}{' '}
                {foodPrice
                  ? '- ' +
                    formatCurrencyByLocalChapter(
                      foodPrice,
                      eventLocalChapterData,
                    )
                  : ''}
              </Tag>
            )}
          </div>
        );
      },
    },
    {
      title: ApplicationString['addAttendeeComponent.table.title.company'],
      dataIndex: 'attendee_company',
      key: 'company',
      width: '15%',
      editable: true,
      render: (text, record) => {
        const JAPAN_LOCAL_CHAPTER_NAME = 'japan';
        const isJapanLocalChapter =
          eventLocalChapterData?.name?.toLowerCase() ===
          JAPAN_LOCAL_CHAPTER_NAME;
        return (
          <div className='option-tag-container'>
            <Tag prefixCls='regularAttendeesTag'>{text}</Tag>
            {isJapanLocalChapter && (
              <>
                <Tag prefixCls='regularAttendeesTag'>
                  {formatAttendeeFieldOrNA(record?.attendee_department)}
                </Tag>
                <Tag prefixCls='regularAttendeesTag'>
                  {formatAttendeeFieldOrNA(record?.attendee_job_title)}
                </Tag>
              </>
            )}
          </div>
        );
      },
    },
    {
      title: ApplicationString['addAttendeeComponent.table.title.price'],
      dataIndex: 'total_cost',
      width: '5%',
      render: (text) => {
        return (
          <h4 className='regularAttendees-price'>
            {formatCurrencyByLocalChapter(text, eventLocalChapterData)}
          </h4>
        );
      },
    },
    {
      title:
        ApplicationString['addAttendeeComponent.table.title.attendanceType'],
      dataIndex: 'registration_type',
      hidden: hideInPersonCheckbox(),
      editable: true,
      width: 180,
      render: (text) => {
        return (
          <h4 className='regularAttendees-price'>
            {text === 'In-Person'
              ? ApplicationString['editableCell.inPerson']
              : text === 'Webcast'
              ? ApplicationString['editableCell.webcast']
              : text || 'N/A'}
          </h4>
        );
      },
    },
    {
      title: ApplicationString['addAttendeeComponent.table.title.action'],
      dataIndex: 'action',
      width: '6%',
      render: (_, record) => {
        return (
          <AdminActionsDropdown
            record={record}
            usedForAttendeeTable={true}
            editBool={true}
            deleteBool={transactionId ? false : true}
            attendeeEditingKey={editingKey}
            handleCancelClick={cancel}
            handleSaveClick={save}
            handleEditClick={edit}
            handleDeleteClick={() => deleteAttendeeById(record.id)}
            setIsAddAttendee={setIsAddAttendee}
          />
        );
      },
    },
  ];

  const shouldEditCell = (column, record) => {
    if (column.dataIndex === 'registration_type') {
      return eventType?.toLowerCase() === 'webcast' || eventISOnline
        ? false
        : true;
    }

    return column.editable ? true : false;
  };
  const mergedColumns = columns
    .filter((column) => {
      return !column.hidden;
    })
    .map((col) => {
      return {
        ...col,
        onCell: (record) => ({
          record,
          dataIndex: col.dataIndex,
          title: col.title,
          editing: isEditing(record) && shouldEditCell(col, record),
          options: col.dataIndex,
        }),
      };
    });
  const handleOk = () => {
    setAttendeeInPersonChecked(true);
    resetAttendanceDependentOptions(form, false);
    setOpenConfirmationPopup(false);
  };
  const handlePopupCancel = () => {
    setAttendeeInPersonChecked(false);
    resetAttendanceDependentOptions(form, true);
    setOpenConfirmationPopup(false);
  };
  return (
    <React.Fragment>
      <Modal
        width={700}
        centered
        title={
          ApplicationString['addAttendeeComponent.button.webcastPopup.title']
        }
        open={openConfirmationPopup}
        onOk={handleOk}
        onCancel={handlePopupCancel}
        cancelText={
          ApplicationString['addAttendeeComponent.button.webcastPopup.confirm']
        }
        okText={
          ApplicationString['addAttendeeComponent.button.webcastPopup.inPerson']
        }
        footer={[
          <div className='button-attendance-container' key=''>
            <Button key='cancel' type='primary' onClick={handlePopupCancel}>
              {
                ApplicationString[
                  'addAttendeeComponent.button.webcastPopup.confirm'
                ]
              }
            </Button>
            <Button key='ok' type='primary' onClick={handleOk}>
              {
                ApplicationString[
                  'addAttendeeComponent.button.webcastPopup.inPerson'
                ]
              }
            </Button>
          </div>,
        ]}>
        <div className='confirm-popup-attendance-type'>
          <p>
            {
              ApplicationString[
                'addAttendeeComponent.button.webcastPopup.description'
              ]
            }
          </p>
        </div>
      </Modal>
      <Row gutter={[0, 30]} className='pbssMainContainerRow'>
        <Col span={24}>
          <div>
            {transactionId ? (
              <SponsorOptionPageHeroText
                title={
                  ApplicationString['userAttendeeCartComponent.afterPayment']
                }
                subTitle={
                  eventName ||
                  ApplicationString[
                    'userAttendeeCartComponent.subHeading.afterPayment'
                  ]
                }
                hideDivider={true}
              />
            ) : (
              <SponsorOptionPageHeroText
                title={
                  ApplicationString['userAttendeeCartComponent.confirm&PayText']
                }
                subTitle={
                  eventName ||
                  ApplicationString['userAttendeeCartComponent.subHeading']
                }
                hideDivider={true}
              />
            )}
          </div>
        </Col>
        {!transactionId && (
          <Col span={24}>
            <SectionLayout>
              <div className='addAttendees-button-wrapper'>
                <NavigationComponent
                  name={
                    ApplicationString[
                      'userAttendeeCartComponent.button.goBacktoAddAttendeeText'
                    ]
                  }
                  urlPath={`addAttendees/${id}`}
                />
              </div>
            </SectionLayout>
          </Col>
        )}
        <Col span={24}>
          <SectionLayout>
            <Form
              form={form}
              onValuesChange={(changedValues) =>
                formValueChangeHandler(form, changedValues)
              }>
              <Skeleton
                loading={loading}
                prefixCls='table-skeleton'
                active
                paragraph={{rows: attendeesData?.length}}>
                <div className='attendees-label'>
                  {
                    ApplicationString[
                      'userAddAttendeeComponent.regularAttendee.label'
                    ]
                  }
                </div>
                <Table
                  prefixCls='attendees-table-container'
                  showExpandColumn={false}
                  components={{
                    body: {
                      cell: (props) => {
                        return (
                          <EditableCell
                            allEventOptionsFoodData={allEventOptionsFoodData}
                            allEventOptionsRegistrationData={
                              allEventOptionsRegistrationData
                            }
                            inPersonRemaining={inPersonRemaining}
                            eventType={eventType}
                            eventLocalChapterData={eventLocalChapterData}
                            companiesData={companiesData}
                            couponVerifiedAttendee={couponVerifiedAttendee}
                            setCouponVerifiedAttendee={
                              setCouponVerifiedAttendee
                            }
                            applyCouponCode={applyCouponCode}
                            attendeesData={attendeesData}
                            transactionId={transactionId}
                            checkedAttendeeInPerson={attendeeInPersonChecked}
                            handleAttendeeInPersonChange={
                              handleAttendeeInPersonChange
                            }
                            id={id}
                            {...props}
                          />
                        );
                      },
                    },
                  }}
                  pagination={false}
                  scroll={{x: Math.max(columns?.length * 150, 1200)}}
                  dataSource={attendeesData}
                  columns={mergedColumns}
                  expandable={{
                    onExpand: (expanded, record) => {
                      return onExpand(expanded, record);
                    },
                    expandedRowKeys: expandedRowKeys,
                    expandedRowRender: (record, index, indent, expanded) => {
                      return (
                        <>
                          {expanded && (
                            <FoodOptionsExpandable
                              record={record}
                              updateRecord={updateRecord}
                              collapseRow={() => collapseRow(record.key)}
                            />
                          )}
                        </>
                      );
                    },
                  }}
                />
              </Skeleton>
            </Form>
          </SectionLayout>
        </Col>
        {!transactionId && (
          <>
            <Col span={24}>
              <SectionLayout>
                <div className='attendees-cart-coupon-container'>
                  <PromotionalCodeInputCart
                    title={
                      ApplicationString[
                        'userAttendeeCartComponent.couponCodeTitle'
                      ]
                    }
                    buttonText={
                      ApplicationString[
                        'userAttendeeCartComponent.couponCodeButtonText'
                      ]
                    }
                    couponVerifiedCart={couponVerifiedCart}
                    onRedeemClick={(Data) => {
                      applyCouponCode({
                        ...Data,
                        eventId: parseInt(id),
                      });
                    }}
                    appliedCartCoupon={appliedCartCoupon}
                  />
                </div>
              </SectionLayout>
            </Col>
            <Col span={24}>
              <SectionLayout>
                <ConfirmationAction
                  heading={
                    ApplicationString[
                      'userAttendeeCartComponent.totalAmountToBePaid'
                    ]
                  }
                  data={attendeesData}
                  submitName={
                    ApplicationString[
                      'userAttendeeCartComponent.confirm&PayText'
                    ]
                  }
                  onConfirm={handleConfirm}
                  onCancel={handleCancel}
                  totalCartPrice={totalCartPrice}
                  disable={isAddAttendee}
                  extra={
                    ApplicationString['attendee-cart-screen-extra-message']
                  }
                  usedForCart
                  eventLocalChapterData={eventLocalChapterData}
                />
              </SectionLayout>
            </Col>
          </>
        )}
        {currentLanguage !== LANGUAGES.JA && (
          <Col span={24}>
            <SectionLayout>
              <CustomCollapse />
            </SectionLayout>
          </Col>
        )}
      </Row>
    </React.Fragment>
  );
};

export default AttendeesCartComponent;
